"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isActive
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(0.8),
  borderRadius: theme.shape.mediumComponentRadius,
  border: isActive ? `2px solid ${theme.palette.text.primary}` : 'none',
  margin: !isActive ? '2px' : 0,
  backgroundColor: theme.palette.grey[100],
  cursor: 'pointer',
  boxSizing: 'border-box'
}));
